import { useTranslation } from 'react-i18next';

import type { IContentBlockBodyProps } from './ContentBlockBody';
import { ErrorMessage } from '~/components/molecules/ErrorMessage';
import { ContentBlock } from './ContentBlock';

export type IContentBlockSuspenseProp = IContentBlockBodyProps & {
  loading?: boolean;
  error?: unknown;
  children: React.ReactNode;
};

export const ContentBlockSuspense: React.FC<IContentBlockSuspenseProp> = (
  props,
) => {
  const { loading, error, children, ...other } = props;
  const { t } = useTranslation();

  return (
    <>
      {error ? (
        <ContentBlock.Body {...other}>
          <ErrorMessage error={error} />
        </ContentBlock.Body>
      ) : loading ? (
        <ContentBlock.Body {...other}>{t('common.loading')}</ContentBlock.Body>
      ) : (
        children
      )}
    </>
  );
};
